import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/caller';
import { CalendarHolidaysViewModel } from '@api/models/CalendarHolidaysViewModel';

// Holiday data is editorially managed via CMS (Kentico) and changes rarely,
// so keep it fresh/cached for ~30 minutes.
const THIRTY_MINUTES = 1000 * 60 * 30;

export const useCalendarHoliday = () => {
  const { data, isError, isLoading } = useQuery<CalendarHolidaysViewModel>(
    ['calendarHolidays'],
    () => callService('ContentsService', 'getCalendarHolidays', {}),
    {
      staleTime: THIRTY_MINUTES,
      cacheTime: THIRTY_MINUTES,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    }
  );

  return { data, isError, isLoading };
};
